import { create } from "zustand";
import type { WorldGoalRow } from "./worldSessionClient";
import { goalParents } from "./useWorldGoals";
export interface GoalContextView {
  worldKey: string;
  goalId: string;
  title: string;
  links: ReadonlyArray<{
    memberId: string;
    reason: string;
    source: "human" | "cleo";
    inheritedFrom: string | null;
    inheritedGoalId: string | null;
  }>;
}
export const useGoalContextView = create<{
  view: GoalContextView | null;
  setView: (view: GoalContextView | null) => void;
}>((set) => ({ view: null, setView: (view) => set({ view }) }));
export function goalContextView(
  worldKey: string,
  goal: WorldGoalRow,
  goals: ReadonlyArray<WorldGoalRow>,
): GoalContextView {
  const byId = new Map(goals.map((g) => [g.goalId, g])),
    seen = new Set<string>(),
    links: GoalContextView["links"][number][] = [];
  const queue = [goal.goalId];
  while (queue.length) {
    const id = queue.shift()!;
    if (seen.has(id)) continue;
    seen.add(id);
    const g = byId.get(id);
    if (!g) continue;
    for (const link of g.contextLinks ?? [])
      links.push({
        ...link,
        inheritedFrom: id === goal.goalId ? null : g.title,
        inheritedGoalId: id === goal.goalId ? null : id,
      });
    queue.push(...goalParents(g));
  }
  return { worldKey, goalId: goal.goalId, title: goal.title, links };
}
